import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Activity, Settings, ShieldAlert, PlusCircle, MessageCircle } from 'lucide-react';

export const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();

    const navItems = [
        { name: 'Overview', path: '/admin', icon: LayoutDashboard },
        { name: 'User Management', path: '/admin/users', icon: Users },
        { name: 'Signals', path: '/admin/signals', icon: Activity },
        { name: 'Create Signal', path: '/admin/create-signal', icon: PlusCircle },
        { name: 'Strategy Control', path: '/admin/strategies', icon: ShieldAlert },
        { name: 'Support Tickets', path: '/admin/support', icon: MessageCircle },
        { name: 'Settings', path: '/admin/settings', icon: Settings },
    ];

    return (
        <div className="flex h-[calc(100vh-64px)] overflow-hidden bg-finance-darker">
            {/* Sidebar */}
            <aside className="w-64 bg-finance-card border-r border-gray-800 flex flex-col hidden md:flex">
                <div className="p-4 border-b border-gray-800">
                    <h2 className="text-finance-accent font-bold text-lg flex items-center gap-2">
                        <ShieldAlert className="w-5 h-5" />
                        Admin Panel
                    </h2>
                </div>
                <nav className="flex-1 overflow-y-auto py-4">
                    <ul className="space-y-1 px-3">
                        {navItems.map((item) => {
                            const active = location.pathname === item.path;
                            const Icon = item.icon;
                            return (
                                <li key={item.name}>
                                    <Link
                                        to={item.path}
                                        className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${active
                                            ? 'bg-finance-accent/20 text-finance-accent'
                                            : 'text-gray-400 hover:text-white hover:bg-gray-800'
                                            }`}
                                    >
                                        <Icon className="w-5 h-5" />
                                        <span className="font-medium">{item.name}</span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                {children}
            </main>
        </div>
    );
};
